<div #modalContainer>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Image Configuration</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="onCloseModal()"
            title="Close Modal"></button>
  </div>

  <div class="modal-body mt-3 d-flex flex-column" [style.max-height.px]="modalHeight" [style.min-height.px]="modalHeight">

    <div [ngbNavOutlet]="nav" class=""></div>

    <div class="d-flex justify-content-center mt-auto img-cfg-mobile-view">
      <div class="mt-2 d-flex justify-content-center img-tab-wrap">
        <div ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-tabs" (navChange)="beforeTabChange($event)">
          <ng-container ngbNavItem="1">
            <button ngbNavLink>
              Dashboard View
            </button>
            <ng-template ngbNavContent>
              <div class="d-flex justify-content-center" *ngIf="isShow">
                <angular-cropper #angularCropperHome [cropperOptions]="configHome" [imageUrl]="inputImg" (crop)="onDashboardViewCrop($event)">
                </angular-cropper>
              </div>
            </ng-template>
          </ng-container>
          <ng-container ngbNavItem="2">
            <button ngbNavLink>
              Detail View
            </button>
            <ng-template ngbNavContent>
              <div class="d-flex justify-content-center" *ngIf="isShow">
                <angular-cropper #angularCropperDetail [cropperOptions]="configDetail" [imageUrl]="inputImg" (crop)="onDetailViewCrop($event)">
                </angular-cropper>
              </div>
            </ng-template>
          </ng-container>
          <ng-container ngbNavItem="3">
            <button ngbNavLink>
              Mobile View
            </button>
            <ng-template ngbNavContent>
              <div class="d-flex justify-content-center" *ngIf="isShow">
                <angular-cropper #angularCropperMobile [cropperOptions]="configMobile" [imageUrl]="inputImg" (crop)="onMobileViewCrop($event)">
                </angular-cropper>
              </div>
            </ng-template>
          </ng-container>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-footer d-flex justify-content-center border-top-0 mb-2 pt-0">
    <button class="btn btn-primary upload-btn w-50" (click)="onSubmit(active)">{{active === '3' ? 'Confirm Image Crop' : 'Next Section'}}</button>
  </div>
</div>
